import NextLink from "next/link";

import { Grid } from "modules/common/components/Grid";
import { useTranslations } from "contexts/LocalizationContext";
import { IconLink } from "modules/common/components/IconLink";
import { ArrowRightIcon } from "styles/icons";

import { Box, Heading, Link, Divider } from "@chakra-ui/react";
import type { CategoryListItemProps } from "./CategoryListItem.d";

const CategoryListItem = ({ category, isLast }: CategoryListItemProps) => {
  const translations = useTranslations();
  const { name, questions, slug } = category;

  return (
    <Grid mb={24}>
      <Heading gridColumn="1 / -1" variant="h2" as="h2" size="md">
        {name}
      </Heading>
      {questions.map((question) => (
        <Link
          as={NextLink}
          key={`${category.name}-${question.name}`}
          href={`/${category.slug}/#${question.slug}`}
          color="primary.900"
          fontSize="lg"
          gridColumn={{ base: "1 / -1", lg: "span 6" }}
        >
          {question.name}
        </Link>
      ))}
      <Box gridColumn="1 / -1">
        <IconLink
          href={`/${slug}/`}
          text={translations("see_all")}
          icon={<ArrowRightIcon mt={0.5} ml={3} />}
          prefetch
        />
      </Box>
      {isLast ? null : <Divider gridColumn="1 / -1" mt={16} />}
    </Grid>
  );
};

export default CategoryListItem;
